export default __webpack_public_path__ + "static/media/crew-2.95944754.png";